import React from 'react';
import exclamation from '../assets/images/icons/square-exclamation.svg';

const ErrorInformation = ({ information }) => {
  if (information) {
    return (
      <div className='error-message'>
        <img src={exclamation} alt='Exclamation' loading='eager'/>
        <p>{information}</p>
      </div>
    );
  } else {
    return null;
  }
};

export default ErrorInformation;